export const READY = "READY"
export const CAN_SUBMIT = "CAN_SUBMIT"
export const DOING = "DOING"
export const DONE = "DONE"
